"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rogueValleyStrawfest = void 0;
const types_1 = require("../types");
const hearthHarmony_1 = require("./hearthHarmony");
const towne_1 = require("./towne");
exports.rogueValleyStrawfest = Object.assign(Object.assign({}, towne_1.towne), { meta: {
        title: "Rogue Valley Strawfest Events",
        description: "Take part of Rogue Valley Strawfest-sponsored events in your community!",
        image: (0, types_1.getFileUrl)("/rogue-valley-strawfest/tags/logo512.png"),
        icon: (0, types_1.getFileUrl)("/rogue-valley-strawfest/tags/favicon.ico"),
    }, company: {
        name: "Rogue Valley Strawfest",
        logo: {
            url: (0, types_1.getFileUrl)("/rogue-valley-strawfest/logo.svg"),
            description: "rogue valley strawfest",
            style: {
                height: 30,
                width: "auto",
            },
            versions: {
                white: { url: (0, types_1.getFileUrl)("/rogue-valley-strawfest/logo-white.svg") },
            },
        },
    }, event: hearthHarmony_1.hearthHarmony.event, footerLinks: [
        {
            text: "Rogue Valley Strawfest Privacy Policy",
            url: "https://www.max.live/privacy-policy",
        },
        { text: "MAX Privacy Policy", url: "https://www.max.live/privacy-policy" },
    ], fanAppUrl: `https://strawfest.live`, artistAppUrl: `https://dashboard.strawfest.live`, regionsCollection: "rogue_valley_strawfest_regions" });
